/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { types } from "mobx-state-tree"
import { QueryBuilder } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { ChildActionsUnionModelSelector } from "./ChildActionsUnionModelSelector"
import { DriverActionDtoModel, DriverActionDtoModelType } from "./DriverActionDtoModel"
import { DriverActionDtoModelSelector } from "./DriverActionDtoModel.base"
import { EngineActionDtoModel, EngineActionDtoModelType } from "./EngineActionDtoModel"
import { EngineActionDtoModelSelector } from "./EngineActionDtoModel.base"
import { PlanningActionOutputDtoModel, PlanningActionOutputDtoModelType } from "./PlanningActionOutputDtoModel"
import { PlanningActionOutputDtoModelSelector } from "./PlanningActionOutputDtoModel.base"
import { PlanningActionsStatusEnumType } from "./PlanningActionsStatusEnum"
import { RouteActionDtoModel, RouteActionDtoModelType } from "./RouteActionDtoModel"
import { RouteActionDtoModelSelector } from "./RouteActionDtoModel.base"
import { VisitActionDtoModel, VisitActionDtoModelType } from "./VisitActionDtoModel"
import { VisitActionDtoModelSelector } from "./VisitActionDtoModel.base"
import { RootStoreType } from "./index"


/**
 * PlanningActionMetadataDuplicateRoutesDtoBase
 * auto generated base class for the model PlanningActionMetadataDuplicateRoutesDtoModel.
 */
export const PlanningActionMetadataDuplicateRoutesDtoModelBase = ModelBase
  .named('PlanningActionMetadataDuplicateRoutesDto')
  .props({
    __typename: types.optional(types.literal("PlanningActionMetadataDuplicateRoutesDto"), "PlanningActionMetadataDuplicateRoutesDto"),
    actionUuid: types.identifier,
    organizationId: types.union(types.undefined, types.integer),
    projectId: types.union(types.undefined, types.integer),
    startDate: types.union(types.undefined, types.string),
    actionName: types.union(types.undefined, types.string),
    status: types.union(types.undefined, types.null, PlanningActionsStatusEnumType),
    detail: types.union(types.undefined, types.null, types.string),
    output: types.union(types.undefined, types.null, types.late((): any => PlanningActionOutputDtoModel)),
    userUuid: types.union(types.undefined, types.string),
    isUndo: types.union(types.undefined, types.boolean),
    isRedo: types.union(types.undefined, types.boolean),
    createdAt: types.union(types.undefined, types.null, types.string),
    updatedAt: types.union(types.undefined, types.null, types.string),
    finishedAt: types.union(types.undefined, types.null, types.string),
    childActions: types.union(types.undefined, types.null, types.array(types.union(types.late((): any => EngineActionDtoModel), types.late((): any => VisitActionDtoModel), types.late((): any => DriverActionDtoModel), types.late((): any => RouteActionDtoModel)))),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class PlanningActionMetadataDuplicateRoutesDtoModelSelector extends QueryBuilder {
  get actionUuid() { return this.__attr(`actionUuid`) }
  get organizationId() { return this.__attr(`organizationId`) }
  get projectId() { return this.__attr(`projectId`) }
  get startDate() { return this.__attr(`startDate`) }
  get actionName() { return this.__attr(`actionName`) }
  get status() { return this.__attr(`status`) }
  get detail() { return this.__attr(`detail`) }
  get userUuid() { return this.__attr(`userUuid`) }
  get isUndo() { return this.__attr(`isUndo`) }
  get isRedo() { return this.__attr(`isRedo`) }
  get createdAt() { return this.__attr(`createdAt`) }
  get updatedAt() { return this.__attr(`updatedAt`) }
  get finishedAt() { return this.__attr(`finishedAt`) }
  output(builder: string | PlanningActionOutputDtoModelSelector | ((selector: PlanningActionOutputDtoModelSelector) => PlanningActionOutputDtoModelSelector) | undefined) { return this.__child(`output`, PlanningActionOutputDtoModelSelector, builder) }
  childActions(builder: string | ChildActionsUnionModelSelector | ((selector: ChildActionsUnionModelSelector) => ChildActionsUnionModelSelector) | undefined) { return this.__child(`childActions`, ChildActionsUnionModelSelector, builder) }
}
export function selectFromPlanningActionMetadataDuplicateRoutesDto() {
  return new PlanningActionMetadataDuplicateRoutesDtoModelSelector()
}

export const planningActionMetadataDuplicateRoutesDtoModelPrimitives = selectFromPlanningActionMetadataDuplicateRoutesDto().actionUuid.organizationId.projectId.startDate.actionName.status.detail.userUuid.isUndo.isRedo.createdAt.updatedAt.finishedAt
